/**
 * A certificate preview error is evidence-retrieval state, NOT issuer expiry.
 * Never infer that a source file was deleted from a failed request.
 * Both view and download use the same guidance.
 */
export function trainingCertificateAccessErrorMessage(status) {
  if (status === 401 || status === 403) {
    return 'Certificate access denied. Check your permissions or session; the certificate is not automatically expired.';
  }
  if (status === 404) {
    return 'Saved certificate could not be found at its linked location. Review earlier uploads before requesting a new copy.';
  }
  if (status === 410) {
    return 'This older certificate uses retired storage. Check saved copies and recovery history; request a current copy only after review.';
  }
  if (status === 503) {
    return 'Certificate storage could not read the saved file. The link may need repair or the service may be unavailable; review file history before replacing it.';
  }
  return 'Certificate could not be opened. Check the saved file link and retry; no training status has changed.';
}
